import Documento from "../assets/img/svg/providers/documento.svg";
import Ubicacion from "../assets/img/svg/providers/ubicacion.svg";
import CentroCarga from "../assets/img/svg/projects/centrodeCarga.svg";
import Proyecto from "../assets/img/svg/projects/Proyecto.svg";
import NuevoProyecto from "../assets/img/svg/projects/NuevoProyecto.svg";

export const itemsSoporte = [
  {
    texto: "Directorio de CFE",
    icon: <img src={Documento} alt="Directorio de CFE" />,
    url: "/soporte/directorio-cfe",
  },
  {
    texto: "Selección de Transformadores",
    icon: <img src={CentroCarga} alt="Selección de Transformadores" />,
    url: "/soporte/seleccion-transformadores",
  },
  {
    texto: "Manuales de HESQ",
    icon: <img src={Documento} alt="Manuales de HESQ" />,
    url: "/soporte/manuales-hesq",
  },
  {
    texto: "Manuales de Implementación y O&M",
    icon: <img src={NuevoProyecto} alt="Manuales de Implementación y O&M" />,
    url: "/soporte/manuales-implementacion",
  },
  {
    texto: "Normativa de CFE",
    icon: <img src={Proyecto} alt="Normativa de CFE" />,
    url: "/soporte/normativa-cfe",
  },
  {
    texto: "Teléfonos de Contacto",
    icon: <img src={Ubicacion} alt="Teléfonos de Contacto" />,
    url: "/soporte/telefonos-de-contacto",
  },
];
